<template>
    <div class="flex flex-column justify-content-center align-items-center">
        <h4 class="text-center">Loading{{ dots }}</h4>
        <ScaleLoader class="m-auto" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const dots = ref('.');

onMounted(() => {
    showLoadingDots();
});

const showLoadingDots = () => {
    // Function to update loader with dots
    function updateLoader() {
        dots.value += '.';
        if (dots.value.length > 3) {
            dots.value = '.';
        }
    }
    // Update loader every 500 milliseconds
    setInterval(updateLoader, 500);
};
</script>
